import { profileApi } from '../profileApi';
import { ProfileView } from '../types/profileTypes';
import { AccessAddEndpointRequest, AccessRemoveEndpointRequest } from '../requests/centerAccessRequests';
import { AccessAddClaimRequest, AccessRemoveClaimRequest } from '../requests/claimAccessRequests';

const accessEndpoints = profileApi.injectEndpoints({
  endpoints: (builder) => ({
    // Add center access to a profile
    // POST /Profile/AddCenterAccess
    addCenterAccess: builder.mutation<ProfileView, AccessAddEndpointRequest>({
      query: (body) => ({
        url: 'Profile/AddCenterAccess',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['myProfile', 'userProfile'],
    }),

    // Remove center access from a profile
    // POST /Profile/RemoveCenterAccess
    removeCenterAccess: builder.mutation<ProfileView, AccessRemoveEndpointRequest>({
      query: (body) => ({
        url: 'Profile/RemoveCenterAccess',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['myProfile', 'userProfile'],
    }),

    // Add claim access to a profile
    // POST /Profile/AddClaimAccess
    addClaimAccess: builder.mutation<ProfileView, AccessAddClaimRequest>({
      query: (body) => ({
        url: 'Profile/AddClaimAccess',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['myProfile', 'userProfile'],
    }),

    // Remove claim access from a profile
    // POST /Profile/RemoveClaimAccess
    removeClaimAccess: builder.mutation<ProfileView, AccessRemoveClaimRequest>({
      query: (body) => ({
        url: 'Profile/RemoveClaimAccess',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['myProfile', 'userProfile'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddCenterAccessMutation,
  useRemoveCenterAccessMutation,
  useAddClaimAccessMutation,
  useRemoveClaimAccessMutation,
} = accessEndpoints;
